export default __webpack_public_path__ + "flash_logo.60fa2c54.png";